import React from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import classNames from 'classnames';

import Select from 'react-select';
import { convertToRupiah } from '../../../utils';
import { getCacheImage } from '../../../config'

const DefaultValue = ({ label }) =>(
  <Content>
    <p>{ label }</p>
  </Content>
)

class RaffleDropDown extends React.Component {
  constructor(props) {
    super(props) 
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  handleMouseDown (event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
  }

  handleMouseEnter (event) {
		this.props.onFocus(this.props.option, event);
  }

  handleMouseMove (event) {
		if (this.props.isFocused) return;
		this.props.onFocus(this.props.option, event);
  }

  render() {
    const { option, className, ...otherProps } = this.props;
    return (
      <WrapperDropDown
        {...otherProps}
        className={classNames(className, "Select__raffle-picker__sneakers--option")}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.label}
      >
        {
          option.value === "" ?
          <DefaultValue className="option" {...option}/>
          :
          <Content className="option">
            <OptionWrapper className="wrapper__option">
              <ImageWrapper className="wrapper__image">
                <ImageRaffle src={getCacheImage(option.urlImage)} alt={option.urlImage} className="wrapper__image-img" />
              </ImageWrapper>
              <TextWrapper className="wrapper__text">
                <Paragraf className="wrapper__text--display-name">{ option.display_name }</Paragraf>
                <Paragraf className="wrapper__text--price">{ option.retailPrice }</Paragraf>
              </TextWrapper>
            </OptionWrapper>
          </Content>
        }
      </WrapperDropDown>
    )
  }
}

const OptionWrapper = styled.div`
  padding: 0px 15px;
  display: flex;
  flex: 1;
  align-items: center;
`;

const WrapperDropDown = styled.div`
  padding: 5px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  padding: 2px;
  padding-bottom: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: space-around;
`;

const ImageWrapLeft = styled.div`
  display: flex;
  justify-content: center;
  width: 40%;
  align-items: center;
`;

const ImageWrapper = styled.div`
  flex: 1;
  margin-right: .5rem;
`;

const TextWrapper = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const ImageRaffle = styled.img`
  width: 100%;
  height: 100%;
`;

const Paragraf = styled.p`
  font-size: 12px;
`;

export default RaffleDropDown;
